exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p.PatientDetailsForm__text{margin-top:var(--vds-space-xl)}.PatientDetailsForm__field,p.PatientDetailsForm__text{margin-bottom:var(--vds-space-md)}.PatientDetailsForm__withRightMargin{margin-right:var(--vds-space-xs)}", ""]);

// exports
exports.locals = {
	"text": "PatientDetailsForm__text",
	"field": "PatientDetailsForm__field",
	"withRightMargin": "PatientDetailsForm__withRightMargin"
};